import React from 'react';
import { Link, withRouter } from "react-router-dom";
import { logUI } from '../../api/andyliticsApi';
import CircularProgressbar from "../common/CircularProgressbar";
import * as Tools from "../../helpers/Tools";

class AssessmentSuccessTile extends React.Component {

    render() {
        const { containerClass, iconInnerClass, showScore, score, overallScoreColor, linkText, linkLogAndylyticsText, linkUrl, cardHeading, subHeading } = this.props;
        return (<div className={`row assessment-success-tile ${containerClass ? containerClass : ""}`}>
            <div className={"col-12 confirm-msg-block"}>
                <div>
                    <div class="row">
                        <div class="col-12">
                            <h1 class="page-heading">{cardHeading}</h1>
                        </div>
                    </div>
                    <div className="row mr-0">
                        <div className="col-12">
                            <div>
                                <p>{subHeading}</p>
                                <p className="status-note">It may take up to <span className="note-msg-highlight">10 business days</span> for your completion status and points to appear in your <span className="note-msg-highlight">Thrive365 portal.</span></p>
                                {linkText && linkUrl && <Link to={linkUrl} className="btn btn-primary" onClick={() => logUI(linkLogAndylyticsText ? linkLogAndylyticsText : "MBHWeb.UI.WellnessTile.Reports.Clicked", new Date(), Tools.getURLPath())}>
                                    {linkText}
                                </Link>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {showScore &&
                    <div><CircularProgressbar percentage={score} overallScoreColor={overallScoreColor} showText="Overall" /></div>
                }
                {iconInnerClass && <div className="row">
                    <div className="confirm-msg-block__note col-12" >
                        <span className={iconInnerClass} /><div className="schedule-note-msg">While completing a preventive care visit is not a Thrive requirement this year, we encourage everyone to continue their preventive care visits as recommended and in accordance with their health care provider.</div>
                    </div>
                </div>}

            </div>
        </div>);
    }

}

export default AssessmentSuccessTile;